import projectImages from './projectImages';





const projects = [

{

    id: "tipax",



    title: "Logistics Operations Platform",



    company: "Tosan Techno / Tipax",



    category: "Internal Operations Product",



    role: "Product Designer",



    duration: "1 Year",



    location: "Remote",



    platform: "Web Platform",



    team: "Product & Development",



    scope: "End-to-End Product Design",



    seoTitle: "Tipax Logistics Platform | Product Design Case Study | Hossein Alavi",



    seoDescription:

        "Product design case study by Hossein Alavi for an internal Tipax logistics operations platform, focused on complex workflows, information hierarchy, and scalable interaction patterns.",



    description:

        "An internal logistics platform designed to help operations teams manage complex day-to-day workflows with more clarity and consistency.",



    tags: [

        "Product Design",

        "Logistics",

        "Internal Tools",

        "Operational Workflows"

    ],



    images: projectImages.tipax,



    website: "https://tipaxco.com/",



    details: {



        heroStatement:

            "The goal wasn't to remove the complexity of logistics — it was to make that complexity easier to understand and operate.",





        overview:

            "The platform is used by internal teams responsible for daily logistics operations. My role was to understand how these workflows worked in practice, identify where complexity was getting in the way, and translate them into a clearer digital experience.",





        problem:

            "The challenge wasn't a single screen. Users had to work with connected tasks, statuses, business rules, and large amounts of operational information at the same time.",





        painPoints: [

            {

                title: "Connected workflows",

                description:

                    "Many tasks depended on previous actions, statuses, or conditions, making the overall process harder to follow."

            },



            {

                title: "High information density",

                description:

                    "Users needed access to a lot of information, but not everything was equally important at every moment."

            },



            {

                title: "Inconsistent patterns",

                description:

                    "Similar actions and states needed to behave more consistently so users didn't have to relearn the interface across different workflows."

            }

        ],





        users: [

            {

                title: "Operations Teams",

                description:

                    "Internal teams responsible for managing and completing daily logistics tasks."

            }

        ],





        businessGoals: [

            "Make daily operational workflows easier to understand and manage.",



            "Create a more consistent experience across different parts of the product.",



            "Build reusable interaction patterns that could support future product development."

        ],





        constraints: [

            "The design had to work with existing operational processes instead of changing the business logic behind them.",



            "Important operational information couldn't simply be removed to make the interface look cleaner.",



            "Solutions needed to be practical for development and scalable as the product evolved.",



            "Product and development collaboration happened remotely."

        ],





        contributions: [

            "Mapped and structured complex operational workflows.",



            "Translated business and operational requirements into clearer product flows.",



            "Designed interfaces for internal logistics teams.",



            "Improved information hierarchy across dense operational screens.",



            "Created more consistent interaction patterns across the product.",



            "Collaborated with product and development teams throughout implementation.",



            "Reviewed implementation to help maintain the intended product experience."

        ],





        process: [

            "Understand the workflow",



            "Map dependencies",



            "Find friction",



            "Simplify the structure",



            "Explore solutions",



            "Review implementation"

        ],





        decisions: [

            {

                title: "Use hierarchy instead of hiding information",

                description:

                    "Rather than removing necessary operational information, I focused on making the most important information easier to find and understand."

            },



            {

                title: "Design around the next action",

                description:

                    "The interface gives more visual priority to what users need to understand or do next in the workflow."

            },



            {

                title: "Reuse familiar patterns",

                description:

                    "Similar actions and states use consistent interaction patterns so users can build familiarity across the product."

            },



            {

                title: "Design for daily use",

                description:

                    "Decisions were evaluated based on how practical they would be during repeated operational tasks, not only on how clean the interface looked."

            }

        ],





        imageCaptions: [

            {

                title: "Operations Overview",

                description:

                    "A clearer overview of operational information and frequently used actions."

            },



            {

                title: "Workflow Management",

                description:

                    "A structured experience for handling connected tasks and system states."

            },



            {

                title: "Information Hierarchy",

                description:

                    "Dense operational information organized around priority and context."

            },



            {

                title: "Detailed Operations View",

                description:

                    "A closer look at how status, information, and actions come together in the workflow."

            }

        ],





        outcome:

            "The redesign created a clearer and more consistent structure for internal logistics workflows. Instead of removing necessary complexity, the experience was organized so users could understand information, actions, and system states more easily.",





        nextSteps: [

            "Validate the redesigned workflows with operations teams during real daily tasks.",



            "Observe where users still hesitate, backtrack, or need additional information.",



            "Use feedback and product behavior to refine information hierarchy and workflow details."

        ],





        learnings: [

            "Complex products don't always need less information. They often need better hierarchy.",



            "Consistency matters even more when users repeat similar tasks every day.",



            "Understanding the real workflow is more important than designing the screen too early."

        ]

    }

},



{

    id: "citynet",



    title: "Travel-Tech Product Ecosystem Redesign",



    company: "Citynet",



    category: "Travel Technology Platform",



    role: "Product Designer",



    duration: "Ongoing",



    location: "Iran",



    platform: "Web Platform",



    team: "Product & Development",



    scope: "Product Foundation, Design System & End-to-End Product Design",



    seoTitle: "Citynet Travel-Tech Ecosystem | Product Design Case Study | Hossein Alavi",



    seoDescription:

        "Product design case study by Hossein Alavi for Citynet, covering a travel-tech product ecosystem, B2B and B2C experiences, internal tools, reporting, and a scalable design system.",



    description:

        "A full redesign of Citynet's travel-tech ecosystem, creating a shared product foundation across customer-facing sales experiences, admin systems, management tools, and reporting products.",



    tags: [

        "Product Design",

        "Travel Tech",

        "B2B",

        "B2C",

        "Design System",

        "Internal Tools"

    ],



    images: projectImages.citynet,



    website: "https://citynet.ir/",



    details: {



        heroStatement:

            "I wasn't redesigning screens. I was designing the foundation they would all share.",





        overview:

            "Citynet is a multi-product travel-tech ecosystem supporting customer-facing travel sales as well as the operational systems behind them. My work focused on redesigning the core product foundation, defining a shared structure across products, and building a design system that could keep the entire ecosystem consistent as it continued to grow.",





        problem:

            "The challenge wasn't simply improving individual interfaces. Multiple sales products, admin systems, management tools, and reporting experiences needed to work as parts of the same ecosystem. Without a shared structure, every new feature risked introducing another interaction pattern, another visual language, and another design decision to maintain.",





        painPoints: [

            {

                title: "Fragmented product experiences",

                description:

                    "Different products and workflows could easily evolve with different structures, interaction patterns, and interface behaviors, making the ecosystem harder to maintain and understand."

            },



            {

                title: "High operational complexity",

                description:

                    "Admin and management products needed to support dense information, multiple actions, statuses, permissions, and operational workflows without overwhelming users."

            },



            {

                title: "Designing for scale",

                description:

                    "Solutions couldn't be designed only for the screen or feature being built today. The foundation needed to support future products, services, and business requirements."

            }

        ],





        users: [

            {

                title: "Travel Customers",

                description:

                    "Users searching for and purchasing travel services through customer-facing sales products."

            },



            {

                title: "Agency & B2B Users",

                description:

                    "Partners and agencies using travel sales and operational tools in business workflows."

            },



            {

                title: "Operations Teams",

                description:

                    "Internal users responsible for reservations, customers, transactions, settings, and daily operational tasks."

            },



            {

                title: "Managers & Administrators",

                description:

                    "Users who need access to reporting, performance data, management tools, and higher-level system controls."

            }

        ],





        businessGoals: [

            "Create one consistent product foundation across the Citynet ecosystem.",



            "Reduce repeated design decisions by defining reusable product patterns.",



            "Create a scalable design system for customer-facing and internal products.",



            "Improve consistency across sales, admin, management, and reporting experiences.",



            "Give product and development teams a shared framework for future features and products."

        ],





        constraints: [

            "The ecosystem includes products with very different users, workflows, and information needs.",



            "Customer-facing experiences needed to stay simple while admin and management systems had to support significantly more complexity.",



            "The shared system needed to create consistency without forcing every product into the same layout or experience.",



            "Existing business logic and operational requirements had to remain supported throughout the redesign.",



            "The design system needed to be flexible enough to grow with new products and travel services."

        ],





        contributions: [

            "Redesigned the core foundation of the Citynet product ecosystem.",



            "Defined a shared structure and product framework across multiple products.",



            "Designed admin and management systems for complex operational workflows.",



            "Designed reporting and data-heavy management experiences.",



            "Designed customer-facing travel sales experiences.",



            "Created shared UX and interaction patterns across B2B and B2C products.",



            "Built and maintained a scalable design system.",



            "Defined reusable components, states, forms, tables, navigation patterns, and system behaviors.",



            "Created consistency across previously separate product experiences.",



            "Collaborated with product and development teams throughout implementation.",



            "Reviewed implementation to maintain design quality and system consistency."

        ],





        process: [

            "Understand the ecosystem",



            "Map recurring patterns",



            "Define the foundation",



            "Design shared behaviors",



            "Build the system",



            "Scale across products"

        ],





        decisions: [

            {

                title: "Standardize the logic, not the product",

                description:

                    "The goal wasn't to make every Citynet product look identical. I created shared rules for hierarchy, components, states, forms, tables, navigation, and interaction while allowing each product to respond to its own context."

            },



            {

                title: "Solve recurring problems once",

                description:

                    "Patterns such as filters, tables, search, status, forms, actions, pagination, empty states, and feedback were designed as reusable product behaviors instead of being solved independently in every product."

            },



            {

                title: "Separate complexity by context",

                description:

                    "Instead of hiding necessary information, the interface prioritizes content based on the user's role, task, and context. A manager, operator, and customer should not see the same hierarchy simply because they use the same ecosystem."

            },



            {

                title: "Treat reporting as a decision tool",

                description:

                    "Reports were approached as more than data presentation. The hierarchy of information was designed to help users move from raw data to understanding, decision-making, and action."

            },



            {

                title: "Use the design system as product infrastructure",

                description:

                    "The design system became the shared product language across the ecosystem, giving design and development teams a common foundation for building and extending products."

            }

        ],





        imageCaptions: [

            {

                title: "Travel Sales Experience",

                description:

                    "A selected customer-facing experience showing how travel services are structured within the shared product language."

            },



            {

                title: "Admin & Operations",

                description:

                    "An operational interface designed to keep complex information, statuses, and actions clear and manageable."

            },



            {

                title: "Management & Reporting",

                description:

                    "A management experience focused on turning dense product and business data into information that is easier to understand and act on."

            },



            {

                title: "Shared Product System",

                description:

                    "A selected product view showing how shared structure, components, and interaction patterns create consistency across the ecosystem."

            }

        ],





        outcome:

            "The redesign established a shared foundation across Citynet's product ecosystem. Customer-facing sales products, admin systems, management tools, and reporting experiences could now grow from the same structural and interaction principles, creating stronger consistency and reducing the need to solve recurring product problems from scratch.",





        nextSteps: [

            "Continue expanding shared patterns as new travel products and operational scenarios are introduced.",



            "Validate complex admin and reporting workflows with users working in real operational contexts.",



            "Refine the design system based on implementation feedback and new product requirements.",



            "Continue reducing unnecessary variation between products while preserving the flexibility each context requires."

        ],





        learnings: [

            "A design system is not a collection of components. It's a shared product language.",



            "Scalability starts with consistent decisions before it reaches reusable components.",



            "Complex systems don't necessarily need fewer features. They need stronger structure.",



            "A product ecosystem becomes easier to grow when teams stop solving the same interaction problems repeatedly."

        ]

    }

},

 {

    id: "blue",



    title: "AI Language Learning Platform",



    company: "BluLexi",



    category: "AI Learning Product",



    role: "Product Designer",



    duration: "",



    location: "",



    platform: "Web Platform",



    team: "Product & Development",



    scope: "End-to-End Product Experience",



    seoTitle: "BluLexi AI Language Learning Platform | Product Design Case Study | Hossein Alavi",



    seoDescription:

        "Product design case study by Hossein Alavi for BluLexi, an AI-assisted language learning platform connecting assessment, practice, feedback, progress, and exam preparation.",



    description:

        "An AI-assisted language learning and exam preparation platform designed to turn practice into a clearer, more intentional learning journey.",



    tags: [

        "Product Design",

        "AI",

        "EdTech",

        "Learning Experience",

        "Web Platform"

    ],



    images: projectImages.blue,



    website: "https://blulexi.com/",



    details: {



        heroStatement:

            "Practice is only useful when learners understand what to improve next.",





        overview:

            "BluLexi brings assessment, practice, feedback, vocabulary, study planning, and exam preparation into one learning experience. The design challenge was not simply to organize these features, but to help learners understand where they are, what needs attention, and what they should do next.",





        problem:

            "Language learners can have access to dozens of exercises and still feel unsure about their progress. The real product challenge was creating direction — connecting assessment, practice, feedback, and progress into a journey that feels intentional rather than fragmented.",





        painPoints: [

            {

                title: "Where do I start?",

                description:

                    "A learner may know they want to improve their language skills without knowing which skill deserves attention first."

            },



            {

                title: "Too many ways to practice",

                description:

                    "Speaking, writing, vocabulary, stories, and mock exams are useful individually, but without clear relationships they can quickly become a collection of disconnected tools."

            },



            {

                title: "Feedback without direction",

                description:

                    "Evaluation alone is not enough. Feedback needs to help learners understand what happened and what they can improve in the next attempt."

            }

        ],





        users: [

            {

                title: "Language Learners",

                description:

                    "Learners who want a clearer way to practice, understand their weaknesses, and make consistent progress."

            },



            {

                title: "Exam-Focused Learners",

                description:

                    "People preparing for formal language exams who need structured practice across multiple skills."

            }

        ],





        businessGoals: [

            "Create a clear journey from assessment to focused practice.",



            "Connect multiple learning tools into one understandable product experience.",



            "Use AI feedback to help learners make more informed decisions about what to practice next.",



            "Make progress easier to understand instead of presenting practice as isolated activities."

        ],





        constraints: [

            "The product includes several different learning activities, each with its own interaction model and information needs.",



            "AI feedback needs to feel useful and actionable without overwhelming the learner.",



            "The experience needs to support both exploration and guided learning without making the interface feel restrictive.",



            "Progress and recommendations need enough context to be meaningful rather than becoming another set of scores and charts."

        ],





        contributions: [

            "Structured the product experience around the learner's journey rather than individual features.",



            "Designed clearer relationships between assessment, practice, feedback, and progress.",



            "Worked on information hierarchy across learning-focused interfaces.",



            "Designed interaction patterns for skill practice and learning feedback.",



            "Explored ways to make AI-generated guidance easier to understand and act on.",



            "Created a more consistent experience across different areas of the learning product."

        ],





        process: [

            "Understand learner context",



            "Identify the next decision",



            "Structure the journey",



            "Reduce cognitive load",



            "Design feedback loops",



            "Refine the experience"

        ],





        decisions: [

            {

                title: "Design around the next decision",

                description:

                    "Instead of treating the product as a menu of learning tools, the experience should help learners understand which action makes the most sense next."

            },



            {

                title: "Turn assessment into direction",

                description:

                    "A level or score is only the beginning. Assessment becomes more valuable when it helps learners understand strengths, weaknesses, and what they should focus on next."

            },



            {

                title: "Make AI feedback actionable",

                description:

                    "Feedback should not stop at evaluation. It should give learners enough context to understand the issue and apply that understanding in their next attempt."

            },



            {

                title: "Show progress through learning, not decoration",

                description:

                    "Progress should help answer a real question: am I improving, and where should I focus now? Visualizations only matter when they support that understanding."

            }

        ],





        imageCaptions: [

            {

                title: "Learning Experience",

                description:

                    "A selected view from the product, designed to keep learning information structured and easy to scan."

            },



            {

                title: "Guided Practice",

                description:

                    "A learning experience focused on helping users move from understanding their current state to taking the next useful action."

            },



            {

                title: "Skill Practice",

                description:

                    "A focused practice experience designed to keep the learner's attention on the task without unnecessary interface complexity."

            },



            {

                title: "Feedback & Progress",

                description:

                    "A product view exploring how feedback and learning progress can become useful input for the learner's next step."

            }

        ],





        outcome:

            "BluLexi was shaped around a simple product principle: learning tools become more valuable when they work together. By connecting assessment, practice, feedback, and progress, the experience creates a clearer path through a product that could otherwise feel like a collection of separate features.",





        nextSteps: [

            "Observe how learners choose what to practice without guidance and compare that behavior with recommended learning paths.",



            "Validate whether AI feedback is specific enough for learners to understand and apply in their next attempt.",



            "Explore how progress can communicate improvement without adding unnecessary metrics or visual noise."

        ],





        learnings: [

            "More practice does not automatically create better learning. Direction matters.",



            "AI feedback becomes useful when it changes what the learner does next.",



            "In learning products, progress should reduce uncertainty — not introduce another dashboard to interpret."

        ]

    }

},

   {

    id: "3click",



    title: "Travel Booking Product Redesign",



    company: "3 Click Group",



    category: "Travel & Booking Platform",



    role: "Product Designer",



    duration: "1.5 Years",



    location: "Tehran, Iran",



    platform: "Web Platform",



    team: "Product & Development",



    scope: "Product Redesign & Design System",



    seoTitle: "3Click Travel Booking Redesign | Product Design Case Study | Hossein Alavi",



    seoDescription:

        "Product design case study by Hossein Alavi for 3Click, covering travel booking experiences, customer-facing products, CMS tools, internal workflows, and a shared design system.",



    description:

        "A redesign across 3Click's travel ecosystem, covering the customer website, booking experiences, internal tools, content management, and a shared design system.",



    tags: [

        "Product Design",

        "Travel",

        "Booking",

        "CMS",

        "Design System"

    ],



    images: projectImages["3click"],



    website: "https://3click.com",



    details: {



        heroStatement:

            "The goal wasn't just to redesign a website — it was to create a more consistent experience across the product ecosystem.",





        overview:

            "3Click included more than a customer-facing travel website. Behind the booking experience, internal teams needed tools for managing content, landing pages, bookings, and partner workflows. My work focused on connecting these different experiences through clearer product structures and a more consistent design language.",





        problem:

            "Different parts of the product served different users and needs. The challenge was to create consistency across the ecosystem without forcing every product to behave or look exactly the same.",





        painPoints: [

            {

                title: "Disconnected product experiences",

                description:

                    "The website, booking flows, and internal tools had different purposes, but still needed to feel like parts of the same product ecosystem."

            },



            {

                title: "Content management dependency",

                description:

                    "Internal teams needed a more practical way to manage content and landing pages without relying on development for every change."

            },



            {

                title: "Booking across different users",

                description:

                    "Booking wasn't only a customer-facing experience. Internal teams and partner agencies also needed clear workflows for managing reservations."

            }

        ],





        users: [

            {

                title: "Travel Customers",

                description:

                    "People using the website to explore travel services and move through the booking experience."

            },



            {

                title: "Internal Teams",

                description:

                    "Teams responsible for managing content, landing pages, bookings, and day-to-day product operations."

            },



            {

                title: "Partner Agencies",

                description:

                    "External partners using booking-related tools and workflows."

            }

        ],





        businessGoals: [

            "Create a more consistent experience across 3Click products.",



            "Make content and landing page management easier for internal teams.",



            "Create clearer booking workflows for internal teams and partner agencies.",



            "Reduce unnecessary dependency on development for content-related tasks.",



            "Build a shared design system that could support future product development."

        ],





        constraints: [

            "Customer-facing experiences needed to stay simple while internal tools had to support more information and operational complexity.",



            "Different products needed a shared design language without becoming identical.",



            "The design system had to remain flexible enough to support different product contexts.",



            "Solutions needed to work within real product and development constraints."

        ],





        contributions: [

            "Redesigned the main 3Click website.",



            "Designed responsive experiences across key customer journeys.",



            "Designed a CMS for managing content and landing pages.",



            "Designed booking management experiences for internal teams.",



            "Designed workflows for partner agencies.",



            "Created shared interaction patterns across different products.",



            "Built and maintained a design system for the product ecosystem.",



            "Collaborated with product and development teams throughout implementation."

        ],





        process: [

            "Understand the product",



            "Map user needs",



            "Structure the experience",



            "Connect product flows",



            "Create reusable patterns",



            "Review implementation"

        ],





        decisions: [

            {

                title: "Consistency without making everything identical",

                description:

                    "The website, CMS, and booking tools had different purposes. I focused on giving them shared typography, components, states, and interaction patterns while keeping each experience appropriate for its users."

            },



            {

                title: "Give internal teams more control",

                description:

                    "The CMS was structured to help content teams manage pages and landing content with less dependency on development."

            },



            {

                title: "Design booking beyond the customer journey",

                description:

                    "Booking was considered from the perspective of customers, internal teams, and partner agencies rather than treating it as a single front-end flow."

            },



            {

                title: "Treat the design system as product infrastructure",

                description:

                    "The design system wasn't only a Figma library. It was intended to make future design and development decisions more consistent and reusable."

            }

        ],





        imageCaptions: [

            {

                title: "Flight Booking Experience",

                description:

                    "A selected screen from the flight product, focused on making booking information easier to understand and act on."

            },



            {

                title: "Flight Selection & Booking Flow",

                description:

                    "Part of the flight booking journey where users review information and continue through the reservation process."

            },



            {

                title: "Add Passenger",

                description:

                    "A passenger entry experience designed to make required information easier to enter and review."

            },



            {

                title: "Passenger Information",

                description:

                    "A structured view of passenger details, with emphasis on clarity, form hierarchy, and reducing avoidable input mistakes."

            }

        ],





        outcome:

            "The work created a more consistent foundation across the 3Click product ecosystem. The website, booking experiences, internal tools, and design system became part of a more connected product structure instead of being treated as isolated interfaces.",





        nextSteps: [

            "Continue validating booking flows with real customer and operational behavior.",



            "Expand reusable patterns as new travel products and booking scenarios are introduced.",



            "Use product feedback to refine form behavior, information hierarchy, and booking interactions."

        ],





        learnings: [

            "Consistency doesn't mean making every product look the same. It means giving them a shared logic.",



            "In multi-product ecosystems, the experience of internal teams matters as much as the customer-facing experience.",



            "A design system becomes valuable when it improves real product decisions, not when it is only a well-organized component library."

        ]

    }

},





{

    id: "darzi",



    title: "Premium Automotive E-commerce",



    company: "Darzi",



    category: "Luxury Automotive E-commerce",



    role: "Product Designer",



    duration: "In Development",



    location: "Iran",



    platform: "E-commerce Website",



    team: "Product & Development",



    scope: "Brand Experience & Product Design",



    seoTitle: "Darzi Automotive E-commerce | Product Design Case Study | Hossein Alavi",



    seoDescription:

        "Product design case study by Hossein Alavi for Darzi, a premium automotive e-commerce experience focused on product confidence, craftsmanship, usability, and brand experience.",



    description:

        "A premium e-commerce experience for genuine leather steering wheel covers, designed for luxury vehicles and built around craftsmanship, material quality, and product confidence.",



    tags: [

        "Product Design",

        "E-commerce",

        "Luxury",

        "Automotive",

        "Brand Experience"

    ],



    images: projectImages.darzi,



    website: null,



    details: {



        heroStatement:

            "When the product is premium, the digital experience has to communicate quality before the customer can physically touch it.",





        overview:

            "Darzi is an e-commerce product currently in development for premium genuine leather steering wheel covers. The challenge was to create a digital experience that could communicate craftsmanship, material quality, and exclusivity while still making product discovery and purchase straightforward.",





        problem:

            "Leather quality, craftsmanship, texture, and fit are physical qualities. Online, customers cannot touch or inspect the product directly, which means the interface has to build confidence through visual hierarchy, product information, photography, and a carefully controlled brand experience.",





        painPoints: [

            {

                title: "Quality is difficult to communicate online",

                description:

                    "Customers cannot physically feel the leather, stitching, or finish, so the experience needs to communicate premium quality through visual and product details."

            },



            {

                title: "Luxury can easily become visual noise",

                description:

                    "Using too many decorative elements can make a premium brand feel less refined. The experience needed to feel luxurious without becoming heavy or overly styled."

            },



            {

                title: "Confidence before purchase",

                description:

                    "Customers need enough information about material, craftsmanship, product details, and suitability before feeling comfortable purchasing a premium automotive accessory."

            }

        ],





        users: [

            {

                title: "Luxury Vehicle Owners",

                description:

                    "Drivers who care about the quality, feel, and appearance of their vehicle interior."

            },



            {

                title: "Detail-Oriented Buyers",

                description:

                    "Customers who pay attention to material, stitching, craftsmanship, and product finish rather than choosing only by price."

            }

        ],





        businessGoals: [

            "Position Darzi as a premium automotive product rather than a generic accessory store.",



            "Communicate genuine leather quality and craftsmanship through the digital experience.",



            "Build enough product confidence for customers to make a purchase without physically inspecting the product.",



            "Create a visual system that can scale as the product catalog grows."

        ],





        constraints: [

            "The experience needed to communicate physical product quality through a digital interface.",



            "Luxury positioning had to come from restraint, typography, spacing, imagery, and hierarchy rather than excessive decoration.",



            "Product information needed to remain clear and practical despite the premium visual direction.",



            "The platform is still in development, so the design needed enough flexibility to evolve with future products and requirements."

        ],





        contributions: [

            "Defined the visual direction for the premium e-commerce experience.",



            "Structured product discovery and product-detail experiences.",



            "Designed information hierarchy around material, craftsmanship, and product details.",



            "Created interaction and layout patterns aligned with the luxury positioning of the brand.",



            "Designed the experience to balance premium visual presentation with practical e-commerce usability.",



            "Created reusable patterns that can support future product categories.",



            "Collaborated with development as the platform moved toward implementation."

        ],





        process: [

            "Understand the product",



            "Define the brand feeling",



            "Prioritize product details",



            "Reduce visual noise",



            "Build purchase confidence",



            "Refine the experience"

        ],





        decisions: [

            {

                title: "Let the product create the luxury",

                description:

                    "Instead of relying on decorative luxury clichés, the visual system gives more space to product imagery, materials, typography, and carefully controlled composition."

            },



            {

                title: "Use restraint as a design language",

                description:

                    "Spacing, hierarchy, contrast, and typography were used to create a premium feeling without filling the interface with unnecessary visual elements."

            },



            {

                title: "Make craftsmanship part of the experience",

                description:

                    "Material, stitching, finish, and construction are important purchase signals, so product details are treated as part of the core experience rather than secondary information."

            },



            {

                title: "Premium should still be easy to buy",

                description:

                    "Luxury positioning should never make basic e-commerce actions harder. Product understanding and purchase actions remain clear and easy to find."

            }

        ],





        imageCaptions: [

            {

                title: "Premium Brand Experience",

                description:

                    "A selected view showing how typography, spacing, imagery, and composition establish the premium character of the product."

            },



            {

                title: "Product Discovery",

                description:

                    "An experience designed to keep the product itself visually dominant while making exploration simple and focused."

            },



            {

                title: "Product Details",

                description:

                    "A closer look at the information needed to communicate material quality, craftsmanship, and product confidence."

            },



            {

                title: "Purchase Experience",

                description:

                    "A selected part of the shopping journey designed to keep purchasing clear while preserving the premium brand experience."

            }

        ],





        outcome:

            "Darzi is still in development. The current design establishes a premium visual and product foundation where craftsmanship and material quality remain central without sacrificing the clarity expected from an e-commerce experience.",





        nextSteps: [

            "Validate which product details customers need most before feeling confident enough to purchase.",



            "Refine the relationship between product photography, material information, and purchase actions.",



            "Extend the visual and interaction system as new vehicle models and product variations are introduced."

        ],





        learnings: [

            "Luxury is often created by what you choose not to add.",



            "When customers cannot touch a physical product, detail and presentation become part of the trust experience.",



            "A premium e-commerce experience still needs to make buying feel effortless."

        ]

    }

},

{

    id: "yahoo",



    title: "Localized Accommodation Booking Platform",



    company: "Yahoo Booking",



    category: "Travel & Accommodation Booking",



    role: "Product Designer",



    duration: "In Development",



    location: "Iran",



    platform: "Web Platform",



    team: "Product & Development",



    scope: "Product Design & Localization",



    seoTitle: "Yahoo Booking | Accommodation Product Design Case Study | Hossein Alavi",



    seoDescription:

        "Product design case study by Hossein Alavi for a localized accommodation booking platform designed around Persian, RTL, travel discovery, comparison, and booking experiences.",



    description:

        "A localized accommodation booking platform inspired by familiar global booking experiences and redesigned around the needs, expectations, and behaviors of users in the Iranian market.",



    tags: [

        "Product Design",

        "Travel",

        "Booking",

        "Localization",

        "Marketplace"

    ],



    images: projectImages.yahoo,



    website: null,



    details: {



        heroStatement:

            "The challenge wasn't to recreate Booking.com — it was to make a familiar booking model feel natural in a different market.",





        overview:

            "Yahoo Booking is an accommodation booking product currently in development for the Iranian market. The product takes inspiration from established global booking patterns while adapting the experience to local user expectations, travel behavior, content structure, and operational requirements.",





        problem:

            "A booking model that works globally cannot simply be translated and reused in another market. Language, pricing expectations, local travel behavior, trust, property information, and the way users compare options can all change how the experience needs to work.",





        painPoints: [

            {

                title: "Finding the right stay quickly",

                description:

                    "Users need to move from a large number of accommodation options to a relevant shortlist without feeling overwhelmed by filters, information, and choices."

            },



            {

                title: "Making comparison easier",

                description:

                    "Price alone is not enough. Location, amenities, room details, policies, and property information need a clear hierarchy so users can compare options with confidence."

            },



            {

                title: "Building confidence before booking",

                description:

                    "Booking accommodation involves commitment. Important information needs to appear at the right moment so users understand exactly what they are choosing before continuing."

            }

        ],





        users: [

            {

                title: "Domestic Travelers",

                description:

                    "People looking for accommodation for leisure, business, or short domestic trips."

            },



            {

                title: "Travel Planners",

                description:

                    "Users comparing several properties, locations, prices, and conditions before making a booking decision."

            }

        ],





        businessGoals: [

            "Create a familiar but locally relevant accommodation booking experience.",



            "Make property discovery and comparison easier across a growing inventory.",



            "Create a clear path from search to property evaluation and booking.",



            "Build reusable product patterns that can support future travel and accommodation scenarios."

        ],





        constraints: [

            "Global booking patterns needed to be adapted rather than copied directly.",



            "The experience needed to support Persian content and right-to-left interface behavior naturally.",



            "Property pages had to present large amounts of information without making the decision process feel heavy.",



            "The product is still evolving, so the design system and interaction patterns needed enough flexibility to support future requirements."

        ],





        contributions: [

            "Designed the core accommodation booking experience.",



            "Structured the journey from search to property evaluation and booking.",



            "Designed search, filtering, and accommodation discovery patterns.",



            "Worked on information hierarchy for property and room details.",



            "Adapted familiar booking patterns for a Persian and right-to-left experience.",



            "Created reusable interface and interaction patterns for the developing product.",



            "Collaborated with product and development teams as the platform evolved."

        ],





        process: [

            "Understand booking behavior",



            "Map the journey",



            "Prioritize information",



            "Reduce decision friction",



            "Localize patterns",



            "Refine the experience"

        ],





        decisions: [

            {

                title: "Localize the logic, not just the language",

                description:

                    "Localization goes beyond translating labels. Layout direction, information order, pricing context, content hierarchy, and interaction patterns all need to feel natural for the local experience."

            },



            {

                title: "Design for comparison",

                description:

                    "Accommodation booking is a comparison-heavy decision. The interface gives users consistent information across properties so options are easier to evaluate against each other."

            },



            {

                title: "Reveal detail at the right moment",

                description:

                    "Property pages contain a lot of information, but showing everything with equal priority creates noise. Important booking information is surfaced progressively as users move closer to a decision."

            },



            {

                title: "Keep familiar patterns where they help",

                description:

                    "Users already understand many common travel-booking conventions. Instead of redesigning familiar interactions for novelty, the product keeps useful conventions and adapts them where the local context requires it."

            }

        ],





        imageCaptions: [

            {

                title: "Accommodation Discovery",

                description:

                    "A selected view of the discovery experience, helping users move from many options toward relevant stays."

            },



            {

                title: "Search & Results",

                description:

                    "A structured results experience designed to make price, location, property information, and key differences easier to scan."

            },



            {

                title: "Property Details",

                description:

                    "A property experience that organizes detailed information around the questions users need answered before making a decision."

            },



            {

                title: "Booking Experience",

                description:

                    "A selected step from the booking journey focused on clarity, confirmation, and helping users understand what they are booking."

            }

        ],





        outcome:

            "Yahoo Booking is still in development. The current design work establishes the product structure, booking patterns, and localized experience needed to grow the platform without relying on a direct copy of an existing global product.",





        nextSteps: [

            "Validate search and comparison behavior with real accommodation-booking scenarios.",



            "Observe which property details have the strongest influence on booking decisions.",



            "Refine the booking flow as inventory, pricing rules, and operational requirements become more mature."

        ],





        learnings: [

            "Localization is a product design problem, not a translation task.",



            "In comparison-heavy products, consistent information structure can matter more than visual novelty.",



            "Familiar interaction patterns are valuable when they reduce learning effort — as long as they still fit the local context."

        ]

    }

},  



];





export default projects;